(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfPluploader', [
    '$parse', function($parse) {
      return {
        restrict: 'A',
        link: (function(_this) {
          return function(scope, elem, attrs) {
            var opts, pluploadOpts, uploader;
            pluploadOpts = attrs.mfPluploader;
            opts = $parse(pluploadOpts)(scope);
            uploader = $(elem).myUploader({
              add_btn: $("." + opts.add_btn),
              plupload_options: {
                url: opts.url,
                filters: [opts.filters],
                onComplete: function(elem, uploader) {
                  if ((opts != null ? opts.callback : void 0) != null) {
                    if (opts.resolve != null) {
                      return opts.callback().then(function(response) {
                        return opts.resolve();
                      });
                    } else {
                      return opts.callback();
                    }
                  }
                }
              }
            });
            return scope.uploader = $(elem).myUploader('getUploader');
          };
        })(this)
      };
    }
  ]);

}).call(this);
